<template>
  <div>
    <el-container>
      <el-main style="text-align: center;background-color: white">

        <div style="display: flex;justify-content: center;align-items: center;width: 80vw;margin-left: 10vw">
          <div style="">
            <el-image :src="titleImage" :fit="'scale-down'" style="width:23vw;height:auto;cursor: pointer" @click="routerHome"></el-image>
          </div>

            <el-menu
                style="display: flex;justify-content: center;align-items: center;width: 35vw;font-size: 0.9vw"
                :default-active="Index"
                class="el-menu-demo"
                mode="horizontal"
                router
            >
              <el-menu-item index="1" route="/" style="font-size: 0.9vw">首页</el-menu-item>
              <el-sub-menu index="2">
                <template #title>公告</template>
                <el-menu-item index="2-1" style="font-size: 0.8vw" route="/Notice">采购公告</el-menu-item>
                <el-menu-item index="2-2" style="font-size: 0.8vw" route="/unNotice">澄清公告</el-menu-item>
              </el-sub-menu>
              <el-sub-menu index="3">
                <template #title>公示</template>
                <el-menu-item index="3-1" style="font-size: 0.8vw" route="/Result">中标候选人公示</el-menu-item>
                <el-menu-item index="3-2" style="font-size: 0.8vw" route="/unResult">中标结果公示</el-menu-item>
              </el-sub-menu>
              <el-menu-item index="4" style="font-size: 0.9vw" route="/financial">金融服务</el-menu-item>
              <el-menu-item index="5" style="font-size: 0.9vw" route="/consult">资讯中心</el-menu-item>
            </el-menu>

          <div style="">
            <div class="search-box">
              <el-input
                  v-model="searchText"
                  :prefix-icon="Search"
                  placeholder="请输入招标公告关键字"
                  :clearable="false"
                  suffix-icon="el-icon-search"
                  class="search-input"
                  style="font-size: 0.8vw"
              />
              <div style="color: #ffffff;background-color: rgb(0,67,148);width: 5.4vw;height: 4vh;font-size: 0.9vw;
              display: flex;justify-content: center;align-items: center;cursor: pointer"
                   @click="search"
              >
                搜索
              </div>
            </div>
          </div>

        </div>

      </el-main>

    </el-container>
  </div>
  <router-view></router-view>


  <footer style="text-align: center; height: auto; background-color: rgb(0,97,214);font-size: 0.85vw;color: #ffffff">
    <div>
      <el-image style="width: 2.85vw;height: 7.2vh" :src="career" :fit="'cover'"/>
    </div>
    <div style="height: 12vh;display: grid;place-items: center;width: auto">
      <div style="text-align: left">
        <el-row>
          <el-col style="margin-left: 2vw">
            <span>主办单位：中国共产党德阳市纪律检查委员会</span>
            <span style="margin-left: 0.5vw">单位地址：四川省德阳市旌阳区松花江北路21号</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="margin-top: 1vh;margin-bottom: 1vh;margin-left: 2vw">
            <span>运营维护单位：四川卓远企业征信咨询有限公司</span>
            <span style="margin-left: 0.5vw">联系电话：0838-2909997</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="margin-left: 2vw">
            <a
                style="color: #ffffff; text-decoration: none; cursor: pointer;"
                onmouseover="this.style.color='#ffffff'; this.style.textDecoration='underline';"
                onmouseout="this.style.color='#ffffff'; this.style.textDecoration='none';"
                href="https://beian.miit.gov.cn/#/Integrated/index"
                target="_blank">
              蜀ICP备2022016621号
            </a>
            <span style="margin-left: 0.5vw">监督电话：(0838) 220 7886</span>
          </el-col>
        </el-row>
      </div>
    </div>
  </footer>

</template>

<script setup>
import titleImage from '@/assets/cover/title.png'
import career from '@/assets/mainvue/sydw.cf3fdd49.png'
import {Search, Edit, Close} from '@element-plus/icons-vue'
const Index = ref('1')

import {ref} from "vue";
import router from "@/router";

// 控制是否显示右下方的弹窗
let show = ref(true)
// 搜索框和按钮
let searchText = ref('')
const search = () => {
  localStorage.setItem("searchText", searchText.value)
  router.push('/search')
}
let mou = ref('home')

// 顶部菜单
let activeIndex = ref(1)

const handleCommand = (command) => {
  router.push(command)
}

const routerHome = () => {
  router.push('/')
}

const changeShow = () => {
  show.value = !show.value
}

</script>

<style>
/* 默认情况下a标签的样式 */
.el-header a {
  text-decoration: none; /* 默认不显示下划线 */
  color: inherit; /* 继承父元素的文本颜色 */
}

/* 当鼠标悬停在a标签上时 */
.el-header a:hover {
  text-decoration: underline; /* 鼠标悬停时显示下划线 */
  color: red; /* 鼠标悬停时字体颜色为红色 */
}

.el-header .topBar {
  margin-left: 16.8vw; /* 将span标签置于离页面的17% */
}

.about-us a:hover {
  text-decoration: none;
}


.search-box {
  display: flex;
  align-items: center;
  border: 0.15vw solid rgb(0,67,148);
  width: 23vw;
  height: 4vh;
}

.search-input {
  width: 100%;
  height: 100%;
}

.el-menu {
  width: 100%;
}

/* 取消旁边的下拉三角符号 */
.sub-menu .el-icon {
  display: none;
}

/* 点击导航栏去除底部白色下划线  todo 存在疑问 含有多个时，无法取消 */
.el-menu-item.is-active {
  border-bottom-color: transparent !important;
}

/* 去除底部白边。*/
.el-menu.el-menu--horizontal {
  border-bottom: 0 !important;
}

/* hover中具体的item时，底色不变 */
/*.el-menu-item {
  background-color: rgb(236, 75, 67) !important;
}*/

footer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.item-left {
  margin-left: -1.7vw;
}

.example-showcase .el-dropdown-link {
  cursor: pointer;
  color: var(--el-color-primary);
  display: flex;
  align-items: center;
}

/* 修改hovera样式 */
.dropdown:hover {
  background-color: rgba(71, 163, 255, 0.75) !important;
}

/* 处理hover离开之后样式恢复原样式 */
.dropdown:not(.is-disabled):focus {
  background-color: rgba(71, 163, 255, 0.75) !important;
}

/* 取消外面的白色border 必须加上!important */
.el-dropdown__popper.el-popper {
  border: none !important;
}

.el-input__wrapper {
  border-radius: 0 !important;
}

.el-input {
  --el-input-hover-border: var(--el-border-color-hover);
  --el-input-focus-border: var(--el-color-primary);
  --el-input-clear-hover-color: none !important;
  --el-input-focus-border-color: none !important;
}

.el-main {
  padding: 2vh 0 !important;
}


.el-menu--horizontal>.el-sub-menu .el-sub-menu__title{
  font-size: 0.9vw;
}

.el-main {
  --el-main-padding: 2vh !important;
}

</style>
